import React, { FC, SyntheticEvent } from 'react';

import PropTypes from 'prop-types';

import Button from '@adsk/alloy-react-button';
import { stylePropType, StylableComponent } from '@adsk/alloy-react-helpers';
import { ChevronDownIcon, RenderIconType } from '@adsk/alloy-react-icon';

type TableExpanderButtonProps = StylableComponent<HTMLDivElement> & {
  onClick?: (e: SyntheticEvent) => void;
  renderIcon?: RenderIconType;
  indentLevel?: number;
  indentDistance?: number;
  isExpanded?: boolean;
};

const TableExpanderButton: FC<TableExpanderButtonProps> = ({
  renderIcon = (p) => <ChevronDownIcon {...p} />,
  indentLevel = 0,
  indentDistance = 18,
  onClick,
  isExpanded = false,
  style,
  className,
}) => {
  return (
    <Button
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      variant={Button.VARIANTS.TERTIARY}
      size={Button.SIZES.SMALL}
      className={className}
      style={[
        {
          color: 'inherit',
          padding: 0,
          marginLeft: indentLevel * indentDistance + 'px',
        },
        style,
      ]}
    >
      {renderIcon?.({
        size: 20,
        style: {
          transform: isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)',
          transition: 'transform 0.15s linear',
        },
      })}
    </Button>
  );
};

TableExpanderButton.propTypes = {
  renderIcon: PropTypes.func,
  indentLevel: PropTypes.number,
  indentDistance: PropTypes.number,
  isExpanded: PropTypes.bool,
  onClick: PropTypes.func,
  style: stylePropType,
  className: PropTypes.string,
};

export default TableExpanderButton;
